module.exports = ".content {\n  width: 100%; }\n\n.outer-content {\n  width: 100%; }\n"